import React, { useState, useEffect, Children } from "react";
import {
  SearchOutlined,
  CheckOutlined,
  CloseOutlined,
  WarningOutlined,
  PlusOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Button,
  theme,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Breadcrumb,
  Form,
  DatePicker,
  Steps,
  Space,
  message,
  Tooltip,
} from "antd";
import FormItem from "antd/es/form/FormItem";
import currencyOptions from "../../../../../config/data/currencies.json";
import customersData from "../../../../../config/data/dummy_data/customers.json";
import { setAlpha } from "@ant-design/pro-components";

const { Content } = Layout;
const { Text, Title } = Typography;
const Search = Input;
const Option = Select;
let selectedSignatries = [];

export default function Mandates() {
  const [current, setCurrent] = useState(0);

  const onChange = (value) => {
    console.log("onChange:", value);
    setCurrent(value);
  };
  return (
    <Card>
      <Row style={{ justifyContent: "space-between" }}>
        <Col span={4}>
          <Card
            style={{
              paddingBottom: "0",
              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.025)",
            }}
          >
            <Steps
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "300px" }}
              items={[
                {
                  title: <Text strong>Add Signatory</Text>,
                },
                {
                  title: <Text strong>Assign Privileges</Text>,
                },
                {
                  title: <Text strong>Assign Limits</Text>,
                },
              ]}
            />
          </Card>
        </Col>
        <Col span={19}>
          <NavContent currentNav={current} />
        </Col>
      </Row>
      <Row style={{ marginTop: "10%" }}>
        <Card></Card>
      </Row>
    </Card>
  );
}

function NavContent(props) {
  const [currentContent, setCurrentContent] = useState(<AddSignatry />);
  const [addedSignatories, setAddedSignatories] = useState([]);
  const { currentNav } = props;

  useEffect(() => {
    if (currentNav === 0) {
      setCurrentContent(
        <AddSignatry
          addedSignatories={addedSignatories}
          setAddedSignatories={setAddedSignatories}
        />
      );
    } else if (currentNav === 1) {
      setCurrentContent(<AssignPrivileges />);
    } else if (currentNav === 2) {
      setCurrentContent(<TransactionLimits />);
    }
  });
  return (
    <>
      <Row>
        <Card
          style={{
            width: "100%",
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.025)",
          }}
        >
          {currentContent}
        </Card>
      </Row>
      <Row>
        <Card></Card>
      </Row>
    </>
  );
}

function AddSignatry(props) {
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const { addedSignatories, setAddedSignatories } = props;

  const noSignatrySelected = () => {
    messageApi.open({ type: "error", content: "Please Select a Customer!" });
  };

  const handleCustomerSelect = (value) => {
    const selected = customersData.find(
      (customer) => customer.customer_id === value
    );
    setSelectedCustomer(selected);
  };

  useEffect(() => {
    selectedSignatries = addedSignatories;
  });

  const handleAddSignatry = () => {
    if (selectedCustomer === null) {
      noSignatrySelected();
      return;
    }

    // Check if the customer is already added
    if (
      addedSignatories.some(
        (signatory) => signatory.customer_id === selectedCustomer.customer_id
      )
    ) {
      messageApi.open({
        type: "error",
        content: "This customer is already added!",
      });
      return;
    }

    // Handle logic for adding signatory using selectedCustomer data
    // ...

    // Add the selected customer to the added signatories
    setAddedSignatories((prevSignatories) => [
      ...prevSignatories,
      selectedCustomer,
    ]);

    // Clear selected customer after adding
    setSelectedCustomer(null);
  };

  const handleDeleteSignatory = (customerId) => {
    const updatedSignatories = addedSignatories.filter(
      (signatory) => signatory.customer_id !== customerId
    );
    setAddedSignatories(updatedSignatories);
    messageApi.open({ type: "success", content: "Successfully deleted!" });
  };

  return (
    <>
      <Form>
        <Row align="middle" gutter={16}>
          <Text strong>Add Signatory</Text>
        </Row>
        <Row>
          <Card
            style={{
              marginTop: 20,
              boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.025)",
            }}
          >
            <Form.Item label={<Text>Customer Identification</Text>}>
              <Select
                showSearch
                placeholder="Search by Customer ID"
                optionFilterProp="children"
                onSelect={handleCustomerSelect}
                style={{ width: 500 }}
                allowClear
              >
                {customersData.map((customer) => (
                  <Option
                    key={customer.customer_id}
                    value={customer.customer_id}
                  >
                    {`${customer.full_name} - ${customer.customer_id}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Row>
              <Form.Item label={<Text>Full Name</Text>}>
                <Input
                  placeholder=""
                  style={{ width: 200 }}
                  disabled
                  value={selectedCustomer ? selectedCustomer.full_name : ""}
                />
              </Form.Item>
            </Row>
            <Row>
              <>
                {contextHolder}
                <Button
                  style={{
                    width: "20%",
                    color: "white",
                    backgroundColor: "#3E2336",
                    marginLeft: "auto",
                  }}
                  onClick={handleAddSignatry}
                >
                  Add
                </Button>
              </>
            </Row>
          </Card>
        </Row>
      </Form>
      <Card style={{ marginTop: 50 }} title={"Added Signatory"}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {Array.isArray(addedSignatories) &&
            addedSignatories.map((signatory) => (
              <div
                style={{
                  marginRight: 20,
                  marginBottom: 20,
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.025)",
                }}
                key={signatory.customer_id}
              >
                <Card
                  title={<Text strong>{signatory.full_name}</Text>}
                  style={{ width: 275 }}
                  extra={
                    <Tooltip title={"Remove"}>
                      <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() =>
                          handleDeleteSignatory(signatory.customer_id)
                        }
                      />
                    </Tooltip>
                  }
                >
                  <Form layout="vertical">
                    <Row>
                      <Form.Item label={"Passport No."}>
                        <Input disabled placeholder={signatory.passport_id} />
                      </Form.Item>
                    </Row>
                    <Row>
                      <Form.Item label={"Customer ID"}>
                        <Input disabled placeholder={signatory.customer_id} />
                      </Form.Item>
                    </Row>
                  </Form>
                </Card>
              </div>
            ))}
        </div>
      </Card>
    </>
  );
}

function AssignPrivileges() {
  const [viewedSignatory, setViewedSignatory] = useState({});
  const [privileges, setPrivileges] = useState([
    { name: "View Account", available: true, assigned: false },
    { name: "View Transactions", available: true, assigned: false },
    { name: "Setup Payment", available: true, assigned: false },
    { name: "Sign Up for New Products", available: true, assigned: false },
    { name: "Add/Remove Transactions", available: true, assigned: false },
    { name: "Add/Remove Mandates", available: true, assigned: false },
  ]);

  const handlePrivilegeClick = (index) => {
    const updatedPrivileges = [...privileges];
    updatedPrivileges[index].available = !updatedPrivileges[index].available;
    updatedPrivileges[index].assigned = !updatedPrivileges[index].assigned;
    setPrivileges(updatedPrivileges);
  };

  const handleSignatorySelect = (value) => {
    const selected = selectedSignatries.find(
      (signatory) => signatory.customer_id === value
    );
    setViewedSignatory(selected);
  };

  return (
    <div>
      <Row style={{ marginBottom: 20 }}>
        <Select
          showSearch
          placeholder="Select Signatory"
          optionFilterProp="children"
          onSelect={handleSignatorySelect}
          style={{ width: 200 }}
          bordered={true}
        >
          {selectedSignatries.map((signatory) => (
            <Option key={signatory.customer_id} value={signatory.customer_id}>
              {signatory.full_name}
            </Option>
          ))}
        </Select>
      </Row>
      <Row>
        <Col span={10}>
          <Card
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            title={"Available Privileges"}
          >
            {privileges.map((privilege, index) => (
              <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 20,
                  }}
                >
                  <Text>{privilege.name}</Text>
                </div>
              </Row>
            ))}
          </Card>
        </Col>
        <Col span={4}>
          <Card style={{ borderRadius: 0 }} title={"Assign"}>
            {privileges.map((privilege, index) => (
              <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                <div
                  style={{
                    borderBottom: "1px solid #f0f0f0",
                    width: "100%",
                    paddingBottom: 20,
                    marginLeft: "40%",
                    marginRight: "40%",
                  }}
                  onClick={() => handlePrivilegeClick(index)}
                >
                  {privilege.assigned ? (
                    <ArrowLeftOutlined />
                  ) : (
                    <ArrowRightOutlined />
                  )}
                </div>
              </Row>
            ))}
          </Card>
        </Col>
        <Col span={10}>
          <Card
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            title={"Assigned Privileges"}
          >
            {privileges
              .filter((privilege) => privilege.assigned)
              .map((privilege, index) => (
                <Row key={index} style={{ marginTop: 0, marginBottom: 20 }}>
                  <div
                    style={{
                      borderBottom: "1px solid #f0f0f0",
                      width: "100%",
                      paddingBottom: 20,
                    }}
                  >
                    <Text>{privilege.name}</Text>
                  </div>
                </Row>
              ))}
          </Card>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Button
          style={{
            width: "15%",
            marginLeft: "auto",
            color: "white",
            backgroundColor: "#3E2336",
          }}
        >
          Save
        </Button>
      </Row>
    </div>
  );
}

function TransactionLimits() {
  const [viewedSignatory, setViewedSignatory] = useState({});

  const handleSignatorySelect = (value) => {
    const selected = selectedSignatries.find(
      (signatory) => signatory.customer_id === value
    );
    setViewedSignatory(selected);
  };
  return (
    <Form>
      <Row>
        {" "}
        <Select
          showSearch
          placeholder="Select Signatory"
          optionFilterProp="children"
          onSelect={handleSignatorySelect}
          style={{ width: 200 }}
          bordered={true}
        >
          {selectedSignatries.map((signatory) => (
            <Option key={signatory.customer_id} value={signatory.customer_id}>
              {signatory.full_name}
            </Option>
          ))}
        </Select>
      </Row>
      <Row>
        <FormItem label={"Transaction Limit"}>
          <Input
            type="number" // This ensures only numbers are accepted
            addonBefore={
              <Select defaultValue="USD" showSearch>
                {currencyOptions.map((currency) => (
                  <Option key={currency.code} value={currency.code}>
                    {currency.name} {currency.symbol}
                  </Option>
                ))}
              </Select>
            }
            placeholder="Enter amount"
          />
        </FormItem>
        <Button
          style={{
            backgroundColor: "#3E2336",
            color: "white",
            width: "10%",
            marginLeft: 20,
          }}
        >
          Add
        </Button>
      </Row>
      <Row>
        <FormItem label={"Approval Limit"}>
          <Input
            type="number" // This ensures only numbers are accepted
            addonBefore={
              <Select defaultValue="USD" showSearch>
                {currencyOptions.map((currency) => (
                  <Option key={currency.code} value={currency.code}>
                    {currency.name} {currency.symbol}
                  </Option>
                ))}
              </Select>
            }
            placeholder="Enter amount"
          />
        </FormItem>
        <Button
          style={{
            backgroundColor: "#3E2336",
            color: "white",
            width: "10%",
            marginLeft: 20,
          }}
        >
          Add
        </Button>
      </Row>
    </Form>
  );
}
